import styled from 'styled-components';

export const AddressCardWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 14rem;
  min-height: 8rem;
  margin: ${props => (props.noMargin ? '0' : '0 1rem 1rem 1rem')};
  padding: ${props => (props.noMargin ? '0' : '1rem')};
  border-radius: 6px;
  border: ${props =>
    `1px solid ${props.selected ? props.theme.wfBlack : 'transparent'}`};
  > h6 {
    margin: ${props =>
      props.size === 'small' ? '0 0 0.25rem 0' : '0 0 0.5rem 0'};
  }
`;

export const ActionsRowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const RadioWrapper = styled.div`
  position: relative;
  display: flex;
  margin: 0.5rem 0;
`;

export const InnerModal = styled.nav`
  position: absolute;
  top: ${props => (props.large ? '-1rem' : 0)};
  left: ${props => (props.large ? '-1rem' : 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${props => (props.large ? 'calc(100% + 2rem)' : '100%')};
  height: ${props => (props.large ? 'calc(100% + 2rem)' : '100%')};
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 6px;
`;

export const InnerModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 1rem;
  background-color: #ffffff;
`;

export const InnerModalActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  button {
    margin: 0.5rem;
  }
`;

export const PhoneAnchor = styled.a`
  h6 {
    display: flex;
    align-items: baseline;
  }
`;
